import { MetadataResponse } from "@/types/metadata";
import axiosInstance from "@/utils/axiosInstance";
import axios from "axios";
import { Country } from "@/types/metadata";
import { getConfig } from "@/lib/runtimeConfig";

const metadataService = {
  getMetadata: async (): Promise<MetadataResponse> => {
    const response = await axiosInstance.get("/backend-api/meta-data/");
    return response.data;
  },
  getCountries: async (): Promise<Country[]> => {
    const response = await axios.get(`${getConfig("NEXT_PUBLIC_META_URL")}api/v0/countries`);
    return response.data.countries;
  },
};

export default metadataService;
